import { ActionKeys } from '~/actions/constants';
import * as invoicesActions from '~/actions/invoices.actions';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as invoicesService from '~/services/invoices.service';
import { fromJSON, JSONInvoice } from '~/types/Invoice';

export function* chargeInvoice(action: ReturnType<typeof invoicesActions.chargeInvoice>) {
  try {
    const result: AxiosResponse<JSONInvoice> = yield call(
      invoicesService.charge,
      action.payload.objectId,
    );
    const invoice = fromJSON(result.data);
    yield put(invoicesActions.chargeInvoiceSuccess(invoice));
  } catch (err) {
    yield put(invoicesActions.chargeInvoiceError(action.payload.objectId, err as Error));
  }
}

export function* fetchInvoices(action: ReturnType<typeof invoicesActions.fetchInvoices>) {
  try {
    const { page, count } = action.payload;
    const result: AxiosResponse<{ results: JSONInvoice[]; count: number }> = yield call(
      invoicesService.get,
      page,
      count,
    );

    const { count: totalCount, results } = result.data;
    const parsedInvoices = results.map(fromJSON);
    const numPages = Math.ceil(totalCount / count);

    yield put(invoicesActions.fetchInvoicesSuccess(parsedInvoices, page, numPages));
  } catch (err) {
    yield put(invoicesActions.fetchInvoicesError(err as Error));
  }
}

export function* fetchInvoice(action: ReturnType<typeof invoicesActions.fetchInvoice>) {
  try {
    const result: AxiosResponse<JSONInvoice> = yield call(
      invoicesService.getById,
      action.payload.invoiceId,
    );
    const invoice = fromJSON(result.data);

    yield put(invoicesActions.fetchInvoiceSuccess(invoice));
  } catch (err) {
    yield put(invoicesActions.fetchInvoiceError(err as Error));
  }
}

export default [
  takeLatest(ActionKeys.INVOICE_CHARGE, chargeInvoice),
  takeLatest(ActionKeys.INVOICES_FETCH, fetchInvoices),
  takeLatest(ActionKeys.INVOICE_FETCH, fetchInvoice),
];
